import React, { useEffect, useState } from "react";
import "./css/booking-detail.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import { setLoading } from "../../../features/common/bookingSlice";
import {
  getBookingDetailById,
  getBookingPdf,
} from "../../../services/userservice";
import * as moment from "moment";

const BookingDetail = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [bookingData, setBookingData] = useState(null);
  //alert(id)
  useEffect(() => {
    fetchBookingData(id);
  }, []);
  const fetchBookingData = async (id) => {
    try {
      dispatch(setLoading());
      const response = await getBookingDetailById(id);
      //console.log("response",response)
      if (response.bookingData) {
        setBookingData(response.bookingData);
      }
      // console.log("response++++++++",response)
    } catch (error) {
      console.log("error");
    }
  };

  const [loader, setLoader] = useState(null);

  const generatePdf = async () => {
    setLoader(true);
    try {
      //alert(id)
      const response = await getBookingPdf(id);
      setLoader(false);
      const file = new Blob([response], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = "ticket.pdf";
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      setLoader(false);
      console.error("Error downloading the PDF:", error);
    }
  };

  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Booking Detail</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="#">Home</a>
                </li>
                <li className="breadcrumb-item active">Booking Detail</li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {/* <div className="callout callout-info">
                <h5>
                  <i className="fas fa-info" /> Note:
                </h5>
                This page has been enhanced for printing. Click the print button
                at the bottom of the invoice to test.
              </div> */}
              <div className="invoice p-3 mb-3">
                {/* title row */}

                <div className="row invoice-info">
                  <div className="col-sm-7 invoice-col">
                    <div className="smt_invoice_left">
                      {/* From */}
                      <address>
                        <strong>SUPERB WORLD TRIP</strong>
                        <br />
                        SECOND FLOOR NEHRU HOUSE
                        <br />
                        4 BAHADUR SHAH ZAFAR MARG ITO
                        <br />
                        NEW DELHI, INDIA
                        <br />
                        Phone: (+91) 9312241999
                        <br />
                        Email: booking@superbworldtrip.com
                      </address>
                    </div>
                  </div>

                  <div className="col-sm-5 invoice-col smt_invoice_right">
                    <div className="smt_invoice_info smt_mb30">
                      <div className="smt_invoice_seperator smt_gray_bg"></div>
                      <div className="smt_invoice_info_list">
                        <h4 className="mb-0">
                          {/* <i className="fas fa-globe" /> Superb Infotech Pvt Ltd. */}
                          <small>
                            <b>Date:</b>{" "}
                            {moment(bookingData?.booking_date).format(
                              "DD-MM-YY hh:mm A"
                            )}
                            {/* {moment.utc(bookingData?.booking_date).tz("Asia/Kolkata").format("DD-MM-YY hh:mm A")} */}
                          </small>
                        </h4>
                        <p className="smt_invoice_number mb-0">
                          <b className="smt_primary_color">Booking ID:</b>{" "}
                          <b className="smt_primary_color">
                            {bookingData?.smt_booking_id}
                          </b>
                        </p>
                        <p className="mb-0">
                          <b className="smt_primary_color">Email ID:</b>{" "}
                          <b className="smt_primary_color">
                            {bookingData?.billing_email}
                          </b>
                          <br />
                        </p>
                        <p>
                          <b className="smt_primary_color">Phone:</b>{" "}
                          <b className="smt_primary_color">
                            {bookingData?.billing_phone_no}
                          </b>
                        </p>
                        {bookingData?.remarks && (
                          <p>
                            <b
                              className="smt_primary_color"
                              style={{ color: "red" }}
                            >
                              Remarks:
                            </b>{" "}
                            <b
                              className="smt_primary_color"
                              style={{ color: "red" }}
                            >
                              {bookingData.remarks}
                            </b>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Onward</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-12 table-responsive smt_style1 smt_mb30">
                        <table className="table table-striped ">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Passenger Name</th>
                              <th>PNR</th>
                              <th>Ticket Number</th>
                              {/* <th>Frequent Flyer No.</th> */}
                            </tr>
                          </thead>
                          <tbody>
                            {bookingData?.passengers.map((passenger, index) => (
                              <tr key={index}>
                                <td className="smt_border_left">{index + 1}</td>
                                <td className="smt_border_left">
                                  {passenger?.title + " "+passenger?.first_name +
                                    " " +
                                    passenger?.last_name}
                                </td>
                                <td className="smt_border_left">
                                  {bookingData?.travelInfos?.[0]?.pnr_number}
                                </td>
                                <td className="smt_border_left">
                                  {!bookingData?.is_lcc
                                    ? passenger?.ticket_number || "---"
                                    : bookingData?.travelInfos?.[0]
                                        ?.pnr_number || "---"}
                                </td>
                                {/* <td className="smt_border_left">------</td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-12 table-responsive">
                        <table className="table table-striped">
                          <thead>
                            <tr>
                              <th
                                className="smt_width_6 smt_semi_bold smt_primary_color smt_gray_bg"
                                colspan="7"
                              >
                                Flight Information
                              </th>
                            </tr>
                            <tr>
                              <th
                                className="smt_width_6 smt_semi_bold smt_primary_color smt_gray_bg text-left"
                                colspan="7"
                              >
                                Departure Flight
                              </th>
                            </tr>
                          </thead>
                          <tbody style={{ backgroundColor: "white" }}>
                            <tr style={{ whiteSpace: "nowrap" }}>
                              {/* <th
                                style={{ verticalAlign: "middle" }}
                                rowspan="10"
                              >
                                From - To
                                <br />
                                Flight Code
                              </th> */}
                            </tr>
                            <tr className="smt_border_top">
                              <th className="smt_width_5 smt_semi_bold smt_primary_color">
                                Flight
                              </th>
                              <th className="smt_width_5 smt_semi_bold smt_primary_color">
                                Departure
                              </th>
                              <th className="smt_width_5 smt_semi_bold smt_primary_color">
                                Arrival
                              </th>
                              <th className="smt_width_5 smt_semi_bold smt_primary_color">
                                Baggage
                              </th>
                              <th className="smt_width_5 smt_semi_bold smt_primary_color">
                                Addon Meal
                              </th>
                              <th className="smt_width_5 smt_semi_bold smt_primary_color">
                                Addon Baggage
                              </th>
                              <th className="smt_width_5 smt_semi_bold smt_primary_color">
                                Seat
                              </th>
                            </tr>

                            {/* Loop through each passenger */}
                            {bookingData?.passengers?.map(
                              (passenger, pIndex) => (
                                <React.Fragment key={passenger.id}>
                                  {/* Passenger Header */}
                                  <tr>
                                    <th className="text-left" colSpan="7">
                                      {passenger.first_name}{" "}
                                      {passenger.last_name}
                                    </th>
                                  </tr>

                                  {/* Now loop through flights for this passenger */}
                                  {(bookingData?.travelInfos?.some(
                                    (f) => f.trip_type === "onward"
                                  )
                                    ? bookingData?.travelInfos?.filter(
                                        (f) => f.trip_type === "onward"
                                      )
                                    : bookingData?.travelInfos
                                  )?.map((flight, fIndex) => {
                                    const baggageList = passenger.baggage || [];
                                    const mealList = passenger.meal_info || [];
                                    const seatList = passenger.seat_info || [];

                                    // Match Add-on baggage
                                    const matchingBaggage = baggageList.filter(
                                      (bag) =>
                                        (bag.origin ===
                                          flight.departure_city_code &&
                                          bag.destination ===
                                            flight.arrival_city_code) ||
                                        (bag.origin ===
                                          bookingData?.flightInfo
                                            ?.departure_city_code &&
                                          bag.destination ===
                                            bookingData?.flightInfo
                                              ?.arrival_city_code)
                                    );

                                    // Match meals
                                    const matchingMeals = mealList.filter(
                                      (meal) =>
                                        meal.origin ===
                                          flight.departure_city_code &&
                                        meal.destination ===
                                          flight.arrival_city_code
                                    );

                                    // Match Seats
                                     const matchingSeats = seatList.filter(
                                      (seat) =>
                                        (seat.origin ===
                                          flight.departure_city_code &&
                                          seat.destination ===
                                            flight.arrival_city_code) ||
                                        (seat.origin ===
                                          bookingData?.flightInfo
                                            ?.departure_city_code &&
                                          seat.destination ===
                                            bookingData?.flightInfo
                                              ?.arrival_city_code)
                                    );

                                    return (
                                      <tr key={fIndex}>
                                        {/* Flight Info */}
                                        <td style={{ width: "25%" }}>
                                          {flight?.airline}{" "}
                                          {flight?.flightNumber}
                                          <br /> Cabin:&nbsp;
                                          <b>{flight?.cabin_class}</b>
                                        </td>

                                        {/* Departure */}
                                        <td
                                          className="smt_border_left"
                                          style={{ width: "25%" }}
                                        >
                                          {flight?.departure_city_code} (
                                          {flight?.departure_city_airport})
                                          <br />
                                          {flight?.departure_city_terminal && (
                                            <>
                                              <b>Terminal:</b>{" "}
                                              {flight?.departure_city_terminal}
                                              <br />
                                            </>
                                          )}
                                          <b>
                                            {moment
                                              .utc(flight?.departure_time)
                                              .format("LLLL")}
                                          </b>
                                        </td>

                                        {/* Arrival */}
                                        <td
                                          className="smt_border_left"
                                          style={{ width: "25%" }}
                                        >
                                          {flight?.arrival_city_code} (
                                          {flight?.arrival_city_airport})
                                          <br />
                                          {flight?.arrival_city_terminal && (
                                            <>
                                              <b>Terminal:</b>{" "}
                                              {flight?.arrival_city_terminal}
                                              <br />
                                            </>
                                          )}
                                          <b>
                                            {moment
                                              .utc(flight?.arrival_time)
                                              .format("LLLL")}
                                          </b>
                                        </td>

                                        {/* Free baggage info */}
                                        <td className="smt_border_left">
                                          Cabin Baggage (per Adult):{" "}
                                          <b>{flight?.cabin_baggage}</b>
                                          <br />
                                          Baggage: <b>{flight?.baggage}</b>
                                        </td>

                                        {/* Addon Meal */}
                                        <td className="smt_border_left">
                                          {matchingMeals.length > 0 ? (
                                            <div>
                                              Meals:{" "}
                                              <b>
                                                {matchingMeals
                                                  .map(
                                                    (meal) =>
                                                      meal.airline_description ||
                                                      meal.description ||
                                                      "Meal"
                                                  )
                                                  .join(", ")}
                                              </b>
                                            </div>
                                          ) : (
                                            "—"
                                          )}
                                        </td>

                                        {/* Addon Baggage */}
                                      
                                        <td className="smt_border_left">
                                          {(() => {
                                            // --- Match segment wise baggage ---
                                            const matchingBaggage =
                                              passenger.baggage?.filter(
                                                (bag) =>
                                                  (bag.origin ===
                                                    flight.departure_city_code &&
                                                    bag.destination ===
                                                      flight.arrival_city_code) ||
                                                  (bag.origin ===
                                                    flight.arrival_city_code &&
                                                    bag.destination ===
                                                      flight.departure_city_code)
                                              ) || [];

                                            // --- Agar match mila toh wahi dikhaye ---
                                            if (matchingBaggage.length > 0) {
                                              return (
                                                <div>
                                                  Extra Baggage:{" "}
                                                  <b>
                                                    {matchingBaggage
                                                      .map(
                                                        (bag) =>
                                                          bag.baggage_description ||
                                                          `${bag.weight} Kg (${bag.code})`
                                                      )
                                                      .join(", ")}
                                                  </b>
                                                </div>
                                              );
                                            }

                                            // --- Agar segment wise match nahi mila toh full journey wala baggage dikhaye ---
                                            if (passenger.baggage?.length > 0) {
                                              return (
                                                <div>
                                                  Extra Baggage (Full Journey):{" "}
                                                  <b>
                                                    {passenger.baggage
                                                      .map(
                                                        (bag) =>
                                                          bag.baggage_description ||
                                                          `${bag.weight} Kg (${bag.code})`
                                                      )
                                                      .join(", ")}
                                                  </b>
                                                </div>
                                              );
                                            }

                                            // --- Agar kuch bhi nahi mila toh dash show kare ---
                                            return "—";
                                          })()}
                                        </td>

                                        {/* Addon Seat */}
                                         <td className="smt_border_left">
                                          {(() => {
                                            // --- Match segment wise baggage ---
                                            const matchingSeats =
                                              passenger?.seat_info?.filter(
                                                (seat) =>
                                                  (seat.origin ===
                                                    flight.departure_city_code &&
                                                    seat.destination ===
                                                      flight.arrival_city_code) ||
                                                  (seat.origin ===
                                                    flight.arrival_city_code &&
                                                    seat.destination ===
                                                      flight.departure_city_code)
                                              ) || [];

                                            // --- Agar match mila toh wahi dikhaye ---
                                            if (matchingSeats?.length > 0) {
                                              return (
                                                <div>
                                                  
                                                  <b>
                                                    {matchingSeats
                                                      .map(
                                                        (seat) =>
                                                          seat?.code ||
                                                          `${seat?.row_number}-${seat?.seat_number}`
                                                      )
                                                      .join(", ")}
                                                  </b>
                                                </div>
                                              );
                                            }

                                            // --- Agar segment wise match nahi mila toh full journey wala baggage dikhaye ---
                                            if (passenger?.baggage?.length > 0) {
                                              return (
                                                <div>
                                                  Seat (Full Journey):{" "}
                                                  <b>
                                                    {passenger?.seat_info
                                                      .map(
                                                        (seat) =>
                                                          seat?.code ||
                                                          `${seat?.row_number}-(${seat?.seat_number})`
                                                      )
                                                      .join(", ")}
                                                  </b>
                                                </div>
                                              );
                                            }

                                            // --- Agar kuch bhi nahi mila toh dash show kare ---
                                            return "—";
                                          })()}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </React.Fragment>
                              )
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                {/* return case for international */}
                {bookingData?.travelInfos?.some(
                  (f) => f.trip_type === "return"
                ) && (
                  <div className="card">
                    <div className="card-header">
                      <h4 className="card-title">Return</h4>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-12 table-responsive">
                          <table className="table table-striped">
                            <thead>
                              <tr>
                                <th
                                  colSpan="7"
                                  className="smt_width_6 smt_semi_bold smt_primary_color smt_gray_bg"
                                >
                                  Flight Information (Return)
                                </th>
                              </tr>
                              <tr className="smt_border_top">
                                <th>Flight</th>
                                <th>Departure</th>
                                <th>Arrival</th>
                                <th>Baggage</th>
                                <th>Addon Meal</th>
                                <th>Addon Baggage</th>
                                <th>Seat</th>
                              </tr>
                            </thead>

                            <tbody>
                              {bookingData?.passengers?.map((passenger) => (
                                <React.Fragment key={passenger.id}>
                                  {/* Passenger Header */}
                                  <tr>
                                    <th className="text-left" colSpan="7">
                                      {passenger.first_name}{" "}
                                      {passenger.last_name}
                                    </th>
                                  </tr>

                                  {/* Return flights */}
                                  {bookingData?.travelInfos
                                    ?.filter((f) => f.trip_type === "return")
                                    ?.map((flight, fIndex) => {
                                      const baggageList =
                                        passenger.baggage || [];
                                      const mealList =
                                        passenger.meal_info || [];

                                      const matchingMeals = mealList.filter(
                                        (meal) =>
                                          meal.origin ===
                                            flight.departure_city_code &&
                                          meal.destination ===
                                            flight.arrival_city_code
                                      );

                                      const matchingBaggage =
                                        baggageList.filter(
                                          (bag) =>
                                            (bag.origin ===
                                              flight.departure_city_code &&
                                              bag.destination ===
                                                flight.arrival_city_code) ||
                                            (bag.origin ===
                                              bookingData?.flightInfo
                                                ?.departure_city_code &&
                                              bag.destination ===
                                                bookingData?.flightInfo
                                                  ?.arrival_city_code)
                                        ) || [];

                                      return (
                                        <tr key={fIndex}>
                                          <td>
                                            {flight?.airline}{" "}
                                            {flight?.flightNumber}
                                            <br /> Cabin:{" "}
                                            <b>{flight?.cabin_class}</b>
                                          </td>

                                          <td className="smt_border_left">
                                            {flight?.departure_city_code} (
                                            {flight?.departure_city_airport})
                                            <br />
                                            {flight?.departure_city_terminal && (
                                              <>
                                                <b>Terminal:</b>{" "}
                                                {
                                                  flight?.departure_city_terminal
                                                }
                                                <br />
                                              </>
                                            )}
                                            <b>
                                              {moment
                                                .utc(flight?.departure_time)
                                                .format("LLLL")}
                                            </b>
                                          </td>

                                          <td className="smt_border_left">
                                            {flight?.arrival_city_code} (
                                            {flight?.arrival_city_airport})
                                            <br />
                                            {flight?.arrival_city_terminal && (
                                              <>
                                                <b>Terminal:</b>{" "}
                                                {flight?.arrival_city_terminal}
                                                <br />
                                              </>
                                            )}
                                            <b>
                                              {moment
                                                .utc(flight?.arrival_time)
                                                .format("LLLL")}
                                            </b>
                                          </td>

                                          <td className="smt_border_left">
                                            Cabin Baggage:{" "}
                                            <b>{flight?.cabin_baggage}</b>
                                            <br />
                                            Baggage: <b>{flight?.baggage}</b>
                                          </td>

                                          <td className="smt_border_left">
                                            {matchingMeals.length > 0
                                              ? matchingMeals
                                                  .map(
                                                    (meal) =>
                                                      meal.airline_description ||
                                                      meal.description ||
                                                      "Meal"
                                                  )
                                                  .join(", ")
                                              : "—"}
                                          </td>

                                         
                                           <td className="smt_border_left">
                                          {(() => {
                                            // --- Match segment wise baggage ---
                                            const matchingBaggage =
                                              passenger.baggage?.filter(
                                                (bag) =>
                                                  (bag.origin ===
                                                    flight.departure_city_code &&
                                                    bag.destination ===
                                                      flight.arrival_city_code) ||
                                                  (bag.origin ===
                                                    flight.arrival_city_code &&
                                                    bag.destination ===
                                                      flight.departure_city_code)
                                              ) || [];

                                            // --- Agar match mila toh wahi dikhaye ---
                                            if (matchingBaggage.length > 0) {
                                              return (
                                                <div>
                                                  Extra Baggage:{" "}
                                                  <b>
                                                    {matchingBaggage
                                                      .map(
                                                        (bag) =>
                                                          bag.baggage_description ||
                                                          `${bag.weight} Kg (${bag.code})`
                                                      )
                                                      .join(", ")}
                                                  </b>
                                                </div>
                                              );
                                            }

                                            // --- Agar segment wise match nahi mila toh full journey wala baggage dikhaye ---
                                            if (passenger.baggage?.length > 0) {
                                              return (
                                                <div>
                                                  Extra Baggage (Full Journey):{" "}
                                                  <b>
                                                    {passenger.baggage
                                                      .map(
                                                        (bag) =>
                                                          bag.baggage_description ||
                                                          `${bag.weight} Kg (${bag.code})`
                                                      )
                                                      .join(", ")}
                                                  </b>
                                                </div>
                                              );
                                            }

                                            // --- Agar kuch bhi nahi mila toh dash show kare ---
                                            return "—";
                                          })()}
                                        </td>
                                         <td className="smt_border_left">
                                          {(() => {
                                            // --- Match segment wise baggage ---
                                            const matchingSeats =
                                              passenger.seat_info?.filter(
                                                (seat) =>
                                                  (seat.origin ===
                                                    flight.departure_city_code &&
                                                    seat.destination ===
                                                      flight.arrival_city_code) ||
                                                  (seat.origin ===
                                                    flight.arrival_city_code &&
                                                    seat.destination ===
                                                      flight.departure_city_code)
                                              ) || [];

                                            // --- Agar match mila toh wahi dikhaye ---
                                            if (matchingSeats.length > 0) {
                                              return (
                                                <div>
                                                  
                                                  <b>
                                                    {matchingSeats
                                                      .map(
                                                        (seat) =>
                                                          seat.code ||
                                                          `${seat.row_number}-${seat.seat_number}`
                                                      )
                                                      .join(", ")}
                                                  </b>
                                                </div>
                                              );
                                            }

                                            // --- Agar segment wise match nahi mila toh full journey wala baggage dikhaye ---
                                            if (passenger?.baggage?.length > 0) {
                                              return (
                                                <div>
                                                  Seat (Full Journey):{" "}
                                                  <b>
                                                    {passenger?.seat_info
                                                      .map(
                                                        (seat) =>
                                                          seat.code ||
                                                          `${seat.row_number}-(${seat.seat_number})`
                                                      )
                                                      .join(", ")}
                                                  </b>
                                                </div>
                                              );
                                            }

                                            // --- Agar kuch bhi nahi mila toh dash show kare ---
                                            return "—";
                                          })()}
                                        </td>
                                        </tr>
                                      );
                                    })}
                                </React.Fragment>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

               
                <hr />
                <div className="row smt_invoice_footer mt-4">
                  <div className="smt_left_footer"></div>
                  <div className="smt_right_footer">
                    <p className="smt_mb3">
                      <b className="smt_primary_color">Payment Details:</b>
                    </p>
                    <table>
                      <tbody>
                        <tr className="smt_border_top">
                          <td className="smt_width_3 smt_border_top_0 smt_bold smt_f16 smt_primary_color">
                            Grand Total{" "}
                          </td>
                          <td className="smt_width_3 smt_border_top_0 smt_bold smt_f16 smt_primary_color smt_text_right">
                            ₹{Math.round(bookingData?.total_amount)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row smt_invoice_footer">
                  <div className="">
                    <p className="smt_mb2 mt-4">
                      <b className="smt_primary_color">
                        Terms &amp; Conditions:
                      </b>
                    </p>
                    <ol className="smt_m0 mt-2 mb-3">
                      <li>
                        All Passengers, including children and infants, must
                        present valid Photo ID at check-in Counter, e.g Aadhar
                        Card, Voter ID Card, Pan Card or other Government Photo
                        IDs.
                      </li>
                      <li>
                        Check-in begains 2 hours prior to the flight and closes
                        45 minutes prior to the scheduled departure for the
                        domestic flights .
                      </li>
                      <li>
                        In case of cancellation / changes by passenger, less
                        than 24 hours before departure, please cancel / change
                        with the airlines directly. Airlines terms & conditions
                        applies.
                      </li>
                      <li>
                        Any Changes to the reservation will result in the
                        Airline's penalty fee plus differance of fare, if any,
                        and with our service charge of Rs. 300 per passenger per
                        sector.{" "}
                      </li>
                      <li>
                        Cancellation of ticket will result in the Airline's fee
                        plus our service charge of Rs. 600 per passenger per
                        sector.
                      </li>
                      <li>
                        Convenience fees and surcharges are non-refundable in
                        case of cancellation of flight by Airline or
                        cancellation request made by the passenger.{" "}
                      </li>
                      <li>
                        We are not responsible for any delay or Cancellation of
                        Flights by the Airline's Contact the Airline or
                        cancellation request made by the passenger.
                      </li>
                      <li>
                        We being a travel agent, all reservations made through
                        our website are as per the terms and conditions of the
                        concerned Airlines. All modifications, cancellations,
                        and refunds are subject to Airline's policy.
                      </li>
                      <li>
                        Please do not share your bank or card details like
                        password, CVV, OTP etc. to any third person or party. We
                        never ask for these details. For any query directly on
                        our official email or contact no. printed on this
                        ticket.
                      </li>
                      <li>
                        Please confirm from the Airline 2/3 days prior to
                        departure about mandotary requirements of Covid-19
                        protocols like RT-PCR test or vaccination etc. and
                        stricly follow them to avoid any inconvenience at the
                        Airport.{" "}
                      </li>
                    </ol>
                  </div>
                </div>
                <div className="row no-print">
                  {bookingData?.booking_status === "SUCCESS" && (
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-primary"
                        style={{ marginRight: 5 }}
                        onClick={generatePdf}
                        disabled={loader}
                      >
                        <i className="fas fa-download" /> Generate PDF
                      </button>

                      {loader && <span>Please wait ...</span>}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BookingDetail;
